import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Autoplay } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import Course_Card from "./Course_Card";

const Course_Slider = ({ Courses }) => {
  return (
    <div className="w-full">
      <Swiper
        modules={[FreeMode, Pagination, Autoplay]}
        freeMode={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        className="mySwiper"
      >
        {Courses?.map((course, index) => (
          <SwiperSlide key={index}>
            <Course_Card course={course} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Course_Slider;
